<template>
    <button :class="['reo-button', type, {'disabled': disabled}]" @click="click">
        <span :class="['reo-button-icon', icon]"></span>
        <slot></slot>
    </button>
</template>

<script>
export default {

    props: {

        icon: String,
        width: String,
        type: {
            
            type: String,
            default () {

                return 'blue';

            }
        },
        disabled: Boolean

    },
    methods: {

        click () {

            !this.disabled && this.$emit( 'click' );

        }

    }

};
</script>

<style scoped lang="less">
    .reo-button{
        box-sizing: border-box;
        line-height: 0.98rem;
        text-align: center;
        font-weight: 500;
        font-size: 0.33rem;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        display: inline-block;
        cursor: pointer;
        padding: 0 0.2rem;
    }
    .reo-button.disabled{
        color: #ccc !important;
        background: #F7F7F7 !important;
        border-color: #ccc !important;
        border-bottom-color: rgba(0,0,0,0) !important;
        border-top-color: rgba(0,0,0,0) !important;
    }
    .reo-button-icon{
        font-weight: 500;
        margin-right: .1rem;
        font-size: .5rem;
        position: relative;
        top: .1rem;
    }
    .reo-button.blue{
        background: @theme-linear-gradient;
        border: 1px solid @theme;
        color: #fff;
    }
    .reo-button.gray{
        background-color: #F7F7F7;
        border: 1px solid #F7F7F7;
        color: @theme;
    }
</style>



// WEBPACK FOOTER //
// src/basic/Button.vue